module.exports = __webpack_public_path__ + "static/img/5.6a312cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/eng/5.png
// module id = R5k3
// module chunks = 0